import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_API_URL } from "../utils/constants";

const CourseFeedbackSlice = createSlice({
    name: "CourseFeedback",
    initialState: {
        loader: false,
        error: null,
        success: null,
        feedbackStatus: {},
        ratingByCourse: {}
    },
    reducers: {
        setLoader: (state, action) => {
            state.loader = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setSuccess: (state, action) => {
            state.success = action.payload;
        },
        resetStatus: (state) => {
            state.error = null;
            state.success = null;
        },
        setFeedbackStatus: (state, action) => {
            const { key, exists } = action.payload;
            state.feedbackStatus[key] = exists;
        },
        setCourseRating: (state, action) => {
            const { key, avgRating, count } = action.payload;
            state.ratingByCourse[key] = { avgRating, count };
        }
    }
});

export const {
    setLoader,
    setError,
    setSuccess,
    resetStatus,
    setFeedbackStatus,
    setCourseRating
} = CourseFeedbackSlice.actions;

export default CourseFeedbackSlice.reducer;

/* ---------------- SUBMIT COURSE FEEDBACK ---------------- */

export function submitCourseFeedback(data) {
    return (dispatch) => {
        dispatch(setLoader(true));
        dispatch(resetStatus());

        axios.post(
            `${BASE_API_URL}/submitCourseFeedback`,
            data,
            {
                headers: {
                    Authorization: localStorage.getItem("token"),
                    "Content-Type": "application/json"
                }
            }
        )
            .then(() => {
                dispatch(setLoader(false));
                dispatch(setSuccess("Feedback submitted successfully"));

                // mark this course as submitted
                const key = `${data.enterpriseId}__${data.courseName}`;
                dispatch(setFeedbackStatus({ key, exists: true }));
            })
            .catch((err) => {
                dispatch(setLoader(false));
                dispatch(
                    setError(
                        err.response?.data?.message ||
                        "Failed to submit course feedback"
                    )
                );
            });
    };
}

/* ---------------- CHECK FEEDBACK STATUS (SINGLE COURSE) ---------------- */

export function checkCourseFeedback(enterpriseId, courseName) {
    return (dispatch, getState) => {
        const key = `${enterpriseId}__${courseName}`;

        // prevent duplicate API calls
        if (getState().CourseFeedback.feedbackStatus[key] !== undefined) {
            return;
        }

        dispatch(setLoader(true));

        axios.post(
            `${BASE_API_URL}/checkCourseFeedback`,
            { enterpriseId, courseName },
            {
                headers: {
                    Authorization: localStorage.getItem("token"),
                    "Content-Type": "application/json"
                }
            }
        )
            .then((res) => {
                dispatch(
                    setFeedbackStatus({
                        key,
                        exists: res.data.exists
                    })
                );
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
                dispatch(setError("Failed to check feedback status"));
            });
    };
}

export function getCourseAverageRating(enterpriseId, courseName) {
    return (dispatch, getState) => {
        const key = `${enterpriseId}__${courseName}`;

        // avoid repeat calls
        if (getState().CourseFeedback.ratingByCourse[key]) return;

        axios.post(
            `${BASE_API_URL}/getCourseAverageRating`,
            { enterpriseId, courseName },
            {
                headers: {
                    Authorization: localStorage.getItem("token"),
                    "Content-Type": "application/json"
                }
            }
        )
            .then((res) => {
                dispatch(setCourseRating({
                    key,
                    avgRating: res.data.avgRating,
                    count: res.data.count
                }));
            })
            .catch(() => {
                // silent fail – rating is optional UI
            });
    };
}

